/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-attachpads',['require','jquery','screens/scenario-mapper/scenario','activities/scenario-activity','activities/activity-openairway'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  //var _ = require('underscore');
  var $ = require('jquery');
  //var Backbone = require('backbone');

  var Scenario = require('screens/scenario-mapper/scenario');
  var ScenarioActivity = require('activities/scenario-activity');
  var ActivityOpenAirway = require('activities/activity-openairway');

  //var Engine = require('core/engine');

  /*****************************************************************************************************************///}

  var ActivityAttachPads = ActivityOpenAirway.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ActivityOpenAirway.prototype.initialize.apply(this, arguments);
    },

    finish: function($performance)
    {
      this.performance = 'average';

      if (this.scoreValue === 4)
        this.performance = ScenarioActivity.PERFORMANCE_GOOD;
      else if (this.scoreValue <= 1)
        this.performance = 'poor';

      this.location.performance = $performance || this.performance;
      this.trigger(Scenario.ACTIVITY_COMPLETE, this);
    },

    setupAttachPads: function()
    {
      ActivityOpenAirway.prototype.setupPlaceHands.apply(this);
    },

    onCorrectDrop: function($dropItem, $drag)
    {
      ////console.log('on up ', $dropItem, $e, $drag.draggable);
      //var $correct = false;
      //var $drop;
      //var $point;
      //var $coords;
      //var $dragPoint;
      //var $dragCoords;
      Draggable.get($drag).disable();
      $drag.addClass('is-correct');
      $dropItem.addClass('is-correct');
      //$drag.draggable.draggable('disable');

      if (this.get('.correctDragHolder').length > 0)
      {
        this.get('.correctDragHolder').append($drag);
      }
      if (this.allComplete())
      {
        this.phaseIndex++;
        this.playAudio('audio-feedback-correct', this.phases[this.phaseIndex - 1], this.loadCurrentPhase, this.killSomeTime);
      }

      $drag.offset($dropItem.offset());//($coords, {time: 0.25, transition: 'easeoutquad'}, false);
      return false;
    },

    onIncorrectDrop: function($scope, $drag)
    {
      $scope.scoreValue--;
      $scope.attempt++;
      if ($scope.attempt >= $scope.maxAttempts)
      {

        $scope.phaseIndex++;
        $scope.moveHandsToCorrectSpots($drag);
        $scope.playAudio('audio-feedback-incorrect-final', $scope.phases[$scope.phaseIndex - 1], $scope.loadCurrentPhase, $scope.killSomeTime);
        //return true;
        return;
      }
      else
      {
        $scope.revertDrag($drag);
        //$drag.returnToOrigin({time: 0.25, transition: 'easeoutquad'});
      }
      $scope.playAudio('audio-feedback-incorrect', $scope.currentPhase);
      return true;
    },

    killSomeTime: function()
    {
      setTimeout($.proxy(this.onKilledTime, this), 2000);
    },

    onKilledTime: function($e)
    {
      //$e.target.removeEventListener(TimerEvent.TIMER, this.onKilledTime);
      this.finish();
    },

  /*****************************************************************************************************************///}

  });

  return ActivityAttachPads;

});

